import React from 'react';
import { BookmarkIcon, XIcon } from 'lucide-react';
import { useDemo } from '../../contexts/DemoContext';
export function RecapNote() {
  const {
    state,
    dispatch
  } = useDemo();
  if (!state.recap) return null;
  return <div className="mx-auto max-w-6xl px-4 pt-6 sm:px-6" data-id="element-541" data-mp="3sjaug35u1zt5">
      <div className="anim-enter flex items-start gap-3 rounded-2xl border border-line bg-sand px-5 py-4 hc-strong" role="note" data-id="element-542" data-mp="1byh5z82m6ii">
        <BookmarkIcon size={20} className="mt-1 shrink-0 text-teal" aria-hidden="true" data-id="element-543" data-mp="2zun6fztp8wbw" />
        <p className="flex-1 text-ink" data-id="element-544" data-mp="34rvqk5yerafs">
          <span className="font-bold" data-id="element-545" data-mp="34syh2crtjav6">Recap: </span>
          {state.recap}
        </p>
        <button type="button" onClick={() => dispatch({
        type: 'CLEAR_RECAP'
      })} className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-forest transition-colors duration-150 hover:bg-cream" aria-label="Dismiss recap" data-id="element-546" data-mp="39q70egopdky0">
          <XIcon size={18} aria-hidden="true" data-id="element-547" data-mp="2m0w69i1uyosu" />
        </button>
      </div>
    </div>;
}